// extracted by mini-css-extract-plugin
export default {"faqs":"Faqs_faqs__ySzVC"};